import Model from '@/models/Model.js';

export default class ObjectiveCriteria extends Model {
    static entity = 'objective_criterias';

    static modelName = 'ObjectiveCriteria';

    static fields() {
        return {
            id: this.attr(null),
            objective_id: this.attr(null),
            description: this.string(''),
            order: this.number(1),

            ...super.fields(),

            objective: this.belongsTo('objectives', 'objective_id'),
        };
    }
}
